import React from 'react';

import { Money, formatMoney } from '@betterment/core';

import { DetailRow } from '../detail-row/DetailRow';
import { DetailRowLabel } from '../detail-row/DetailRowLabel';
import { DetailRowValue } from '../detail-row/DetailRowValue';

export interface TaxImpactEstimateLoadedProps {
  netEstimatedTaxes: Money;
}

export const TaxImpactEstimateLoaded: React.FC<TaxImpactEstimateLoadedProps> = ({ netEstimatedTaxes }) => {
  const formattedTaxes = formatMoney(netEstimatedTaxes);

  return (
    <DetailRow data-testid="tax-impact-estimate">
      <DetailRowLabel>Est. tax impact</DetailRowLabel>
      <DetailRowValue>{formattedTaxes}</DetailRowValue>
    </DetailRow>
  );
};
